const providerAliases = {
  'el casino': 'elcasino',
  'golden race': 'goldenrace',
  playingo: 'playngo',
  spinometal: 'spinomenal',
  'the hood': 'the-hood',
};
const providerCategorySuffixes = new Set(['crash', 'live-casino', 'slots']);

const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const normalizeProviderValue = value => {
  const normalized = (value ?? '').toString().toLowerCase();
  const parts = normalized.split(':');
  const rawKey =
    parts.length > 1 && providerCategorySuffixes.has(parts[parts.length - 1].trim())
      ? parts[0].trim()
      : parts[parts.length - 1].trim();
  const aliasKey = rawKey;
  return providerAliases[aliasKey] ?? aliasKey;
};

const uniqueBy = (arr, key) => Array.from(new Map(arr.map(item => [item[key], item])).values());

const isEqualByKeys = (arr1, arr2, keys) => {
  if (arr1?.length !== arr2?.length) return false;
  const pick = (obj, ks) => ks.reduce((acc, k) => ({ ...acc, [k]: obj?.[k] }), {});
  return arr1.every((item, idx) => {
    const a = pick(item, keys);
    const b = pick(arr2[idx], keys);
    return keys.every(k => a[k] === b[k]);
  });
};

const reorderInsideType = (list, type, startIndex, endIndex) => {
  const typedItems = list.filter(item => item.type === type);
  const reorderedTypedItems = reorder(typedItems, startIndex, endIndex);

  let typedIndex = 0;

  return list.map(item => {
    if (item.type !== type) return item;
    return reorderedTypedItems[typedIndex++];
  });
};

const ONLY_DIGITS_REGEX = /^\d+$/;

export { normalizeProviderValue, uniqueBy, isEqualByKeys, reorderInsideType, ONLY_DIGITS_REGEX };
